// Naval creature prefabs: the shared `ship()` rig builder and the four hulls
// (trade, transport, war, galleon). Copied from adventure-craft.
import { box } from './creatures_shared.js';
import type { CharacterPart, CharacterPrefab } from './types.js';

const ship = (
  hullColor: string,
  deckColor: string,
  sailColor: string,
  w: number,
  d: number,
  h: number,
): CharacterPart[] => {
  const parts: CharacterPart[] = [
    // Hull — tapered shape.
    {
      name: 'hull',
      voxels: box(-Math.floor(w / 2), 0, -Math.floor(d / 2), w, Math.ceil(h * 0.4), d, hullColor),
    },
    // Deck.
    {
      name: 'deck',
      voxels: box(
        -Math.floor(w * 0.4),
        Math.ceil(h * 0.4),
        -Math.floor(d * 0.3),
        Math.ceil(w * 0.8),
        1,
        Math.ceil(d * 0.6),
        deckColor,
      ),
    },
  ];
  // Mast + sail if sail color provided.
  if (sailColor) {
    const mx = 0;
    const my = Math.ceil(h * 0.4) + 1;
    const mz = 0;
    parts.push({
      name: 'mast',
      voxels: [
        { x: mx, y: my, z: mz, color: '#8b6914' },
        { x: mx, y: my + 1, z: mz, color: '#8b6914' },
        { x: mx, y: my + 2, z: mz, color: '#8b6914' },
        { x: mx, y: my + 3, z: mz, color: '#8b6914' },
      ],
    });
    parts.push({
      name: 'sail',
      voxels: [
        { x: mx - 1, y: my, z: mz, color: sailColor },
        { x: mx, y: my, z: mz, color: sailColor },
        { x: mx + 1, y: my, z: mz, color: sailColor },
        { x: mx - 1, y: my + 1, z: mz, color: sailColor },
        { x: mx, y: my + 1, z: mz, color: sailColor },
        { x: mx + 1, y: my + 1, z: mz, color: sailColor },
        { x: mx - 1, y: my + 2, z: mz, color: sailColor },
        { x: mx, y: my + 2, z: mz, color: sailColor },
        { x: mx + 1, y: my + 2, z: mz, color: sailColor },
      ],
    });
  }
  return parts;
};

export const trade_ship: CharacterPrefab = {
  name: 'Trade Ship',
  maxHp: 60,
  parts: ship('#8b6914', '#c4a45a', '#f5f0e0', 6, 4, 4),
};

export const transport_ship: CharacterPrefab = {
  name: 'Transport Ship',
  maxHp: 80,
  parts: ship('#6b4914', '#b8943a', '#e8dcc8', 7, 5, 4),
};

export const warship: CharacterPrefab = {
  name: 'Warship',
  maxHp: 120,
  parts: ship('#4a3520', '#8b7355', '#cc3333', 6, 4, 5),
};

export const galleon: CharacterPrefab = {
  name: 'Galleon',
  maxHp: 180,
  parts: ship('#3a2518', '#6b4c32', '#d4af37', 8, 6, 6),
};
